(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('CustomUpdateTagsDialogController', CustomUpdateTagsDialogController);

    CustomUpdateTagsDialogController.$inject = ['$timeout', 'TabObjects', 'TabActionsQueue', '$state', '$uibModalInstance', 'numObjects'];

    function CustomUpdateTagsDialogController($timeout, TabObjects, TabActionsQueue, $state, $uibModalInstance, numObjects) {
        var vm = this;

        vm.picker = false;
        vm.tabobjects = TabObjects.query();
        vm.tabactionsqueues = TabActionsQueue.query();
        vm.numObjects = numObjects;
        vm.tag = new Date().toDateString();
        vm.firmware = false;
        vm.forced = false;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.save = function () {
            vm.isSaving = true;
            $uibModalInstance.close({tag: vm.tag, date: vm.date, updFirmware: vm.firmware, forced: vm.forced});
            vm.isSaving = false;
        };

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
